import React, { useEffect, useState } from 'react';

const CanopyHeightComponent = ({
  isVisible,
  opacity = 100,
  id,
  mapInstance,
}) => {
  const [tileUrl, setTileUrl] = useState(null);

  useEffect(() => {
    if (!isVisible) return;

    async function fetchMapId() {
      try {
        const response = await fetch(`/api/mapid`);
        if (!response.ok) {
          throw new Error(`Server error: ${response.status} ${response.statusText}`);
        }
        const { mapid, token } = await response.json();
        const url = token
          ? `https://earthengine.googleapis.com/v1/${mapid}/tiles/{z}/{x}/{y}?token=${token}`
          : `https://earthengine.googleapis.com/v1/${mapid}/tiles/{z}/{x}/{y}`;
        setTileUrl(url);
      } catch (err) {
        console.error('Error fetching mapId:', err);
      }
    }

    fetchMapId();
  }, [isVisible]);

  useEffect(() => {
    if (!mapInstance) return;
    const layerId = id;

    if (tileUrl && isVisible) {
      // Remove existing layer/source if they exist
      if (mapInstance.getLayer(layerId)) {
        mapInstance.removeLayer(layerId);
      }
      if (mapInstance.getSource(layerId)) {
        mapInstance.removeSource(layerId);
      }

      // Add new source
      mapInstance.addSource(layerId, {
        type: 'raster',
        tiles: [tileUrl],
        tileSize: 256,
      });

      // Add the new layer
      mapInstance.addLayer({
        id: layerId,
        type: 'raster',
        source: layerId,
        paint: {
          'raster-opacity': opacity / 100,
        },
        layout: {
          visibility: isVisible ? 'visible' : 'none',
        },
      });
    }

    // Cleanup
    return () => {
      if (mapInstance.getLayer(layerId)) {
        mapInstance.removeLayer(layerId);
      }
      if (mapInstance.getSource(layerId)) {
        mapInstance.removeSource(layerId);
      }
    };
  }, [mapInstance, tileUrl, isVisible, opacity, id]);

  return null;
};

export default CanopyHeightComponent;
